import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_HOST_API
});

const getSessionId = () => {
  return localStorage.getItem('sessionId');
};

axiosInstance.interceptors.request.use(
  (config) => {
    const sessionId = getSessionId();
    config.headers['X-Client-Type'] = 'web_client';
    config.headers.Authorization = `Bearer ${ sessionId }`;

    if (sessionId) {
      config.params = {
        ...config.params
      };
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('sessionId');
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
